<nav class="left-nav" aria-label="Main navigation">
  <div>
    <a routerLink="/" aria-label="NYC Public Schools - Home">
      <img class="k-cursor-pointer" src="./assets/nycps-logo.svg" alt="NYC Public Schools" />
    </a>
  </div>
  <div *ngIf="showNavigation()" class="navigation-container">
    <a *ngFor="let item of navigationItems" class="link-item navigation-item" [routerLink]="item.route"
      routerLinkActive="active">
      <div class="icon-test-container">
        <ng-container>
          <kendo-svg-icon class="nav-icon" [icon]="item.svg" size="xlarge"></kendo-svg-icon>
        </ng-container>
        <div>{{ item.name }}</div>
      </div>
    </a>
  </div>
</nav>